export class BidRange {
    id!: string
    name!: string
    low!: number
    high!: number
}
